export default "__VITE_ASSET__CHT$Gx11__"